// Mock API implementation for static, frontend-only running.
// Decouples the application from a backend and database by utilizing localStorage for state.

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const defaultProducts = [
    {
        id: 1,
        name: 'Super Hero Action Figure',
        description: '12" articulated superhero figure with accessories',
        price: 29.99,
        category: 'Action Figures',
        age_range: '3+',
        stock_quantity: 50,
        image_url: 'https://images.unsplash.com/photo-1608889335941-32ac5f2041b9?w=500',
        featured: true,
        created_at: new Date('2026-05-01T10:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-01T10:00:00.000Z').toISOString()
    },
    {
        id: 2,
        name: 'Wooden Building Blocks',
        description: '100 piece natural wooden blocks set',
        price: 39.99,
        category: 'Building Sets',
        age_range: '2+',
        stock_quantity: 30,
        image_url: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=500',
        featured: true,
        created_at: new Date('2026-05-02T11:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-02T11:00:00.000Z').toISOString()
    },
    {
        id: 3,
        name: 'Teddy Bear',
        description: 'Soft plush bear, 12 inches',
        price: 24.99,
        category: 'Soft Toys',
        age_range: '0+',
        stock_quantity: 100,
        image_url: 'https://images.unsplash.com/photo-1563227812-0ea4c22e6cc8?w=500',
        featured: true,
        created_at: new Date('2026-05-03T12:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-03T12:00:00.000Z').toISOString()
    },
    {
        id: 4,
        name: 'Math Learning Kit',
        description: 'Interactive math learning set',
        price: 34.99,
        category: 'Educational Toys',
        age_range: '5+',
        stock_quantity: 45,
        image_url: 'https://images.unsplash.com/photo-1594322436404-5a0526db4d13?w=500',
        featured: false,
        created_at: new Date('2026-05-04T13:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-04T13:00:00.000Z').toISOString()
    },
    {
        id: 5,
        name: 'Chess Set',
        description: 'Classic wooden chess board game',
        price: 49.99,
        category: 'Board Games',
        age_range: '8+',
        stock_quantity: 25,
        image_url: 'https://images.unsplash.com/photo-1586165368502-1bad197a6461?w=500',
        featured: true,
        created_at: new Date('2026-05-05T14:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-05T14:00:00.000Z').toISOString()
    },
    {
        id: 6,
        name: 'Dinosaur Toy Set',
        description: 'Set of 12 realistic dinosaur figures',
        price: 19.99,
        category: 'Action Figures',
        age_range: '3+',
        stock_quantity: 75,
        image_url: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=500',
        featured: false,
        created_at: new Date('2026-05-06T15:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-06T15:00:00.000Z').toISOString()
    },
    {
        id: 7,
        name: 'Art & Craft Kit',
        description: 'Complete art supplies for kids',
        price: 44.99,
        category: 'Educational Toys',
        age_range: '4+',
        stock_quantity: 60,
        image_url: 'https://images.unsplash.com/photo-1594322436404-5a0526db4d13?w=500',
        featured: true,
        created_at: new Date('2026-05-07T16:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-07T16:00:00.000Z').toISOString()
    },
    {
        id: 8,
        name: 'Puzzle Game',
        description: '100 piece jigsaw puzzle',
        price: 14.99,
        category: 'Board Games',
        age_range: '6+',
        stock_quantity: 120,
        image_url: 'https://images.unsplash.com/photo-1586165368502-1bad197a6461?w=500',
        featured: false,
        created_at: new Date('2026-05-08T17:00:00.000Z').toISOString(),
        updated_at: new Date('2026-05-08T17:00:00.000Z').toISOString()
    }
];

const getStoredProducts = () => {
    const stored = localStorage.getItem('tfm_products');
    if (!stored) {
        localStorage.setItem('tfm_products', JSON.stringify(defaultProducts));
        return defaultProducts;
    }
    return JSON.parse(stored);
};

const saveStoredProducts = (products) => {
    localStorage.setItem('tfm_products', JSON.stringify(products));
};

// Auth APIs
export const login = async (email, password) => {
    await delay(300);
    if (email === 'admin@tfm.com' && password === 'Admin@123') {
        const responseData = {
            token: 'mock-jwt-token-xyz-12345',
            user: {
                id: 1,
                username: 'admin',
                email: 'admin@tfm.com',
                role: 'admin'
            }
        };
        localStorage.setItem('token', responseData.token);
        localStorage.setItem('user', JSON.stringify(responseData.user));
        return responseData;
    } else {
        const error = new Error('Unauthorized');
        error.response = {
            data: {
                message: 'Invalid email or password. Please use admin@tfm.com / Admin@123'
            }
        };
        throw error;
    }
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
};

// Product APIs
export const getProducts = async (filters = {}) => {
    await delay(200);
    let list = getStoredProducts();

    if (filters.featured !== undefined) {
        const isFeatured = filters.featured === 'true' || filters.featured === true;
        list = list.filter((p) => p.featured === isFeatured);
    }
    if (filters.category) {
        list = list.filter(
            (p) => p.category && p.category.toLowerCase() === filters.category.toLowerCase()
        );
    }

    return { products: list };
};

export const getProduct = async (id) => {
    await delay(200);
    const list = getStoredProducts();
    const product = list.find((p) => String(p.id) === String(id));
    if (product) {
        return { product };
    } else {
        const error = new Error('Not Found');
        error.response = {
            data: {
                message: 'Product not found'
            }
        };
        throw error;
    }
};

export const createProduct = async (productData) => {
    await delay(300);
    const list = getStoredProducts();
    const nextId = list.reduce((max, p) => (p.id > max ? p.id : max), 0) + 1;
    const newProduct = {
        ...productData,
        id: nextId,
        price: parseFloat(productData.price) || 0,
        stock_quantity: parseInt(productData.stock_quantity) || 0,
        featured: !!productData.featured,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
    };
    list.push(newProduct);
    saveStoredProducts(list);
    return { product: newProduct };
};

export const updateProduct = async (id, productData) => {
    await delay(300);
    const list = getStoredProducts();
    const index = list.findIndex((p) => String(p.id) === String(id));
    if (index !== -1) {
        const updatedProduct = {
            ...list[index],
            ...productData,
            price: parseFloat(productData.price) || 0,
            stock_quantity: parseInt(productData.stock_quantity) || 0,
            featured: !!productData.featured,
            updated_at: new Date().toISOString()
        };
        list[index] = updatedProduct;
        saveStoredProducts(list);
        return { product: updatedProduct };
    } else {
        const error = new Error('Not Found');
        error.response = {
            data: {
                message: 'Product not found'
            }
        };
        throw error;
    }
};

export const deleteProduct = async (id) => {
    await delay(300);
    const list = getStoredProducts();
    const filtered = list.filter((p) => String(p.id) !== String(id));
    if (filtered.length < list.length) {
        saveStoredProducts(filtered);
        return { success: true };
    } else {
        const error = new Error('Not Found');
        error.response = {
            data: {
                message: 'Product not found'
            }
        };
        throw error;
    }
};

// Dummy axios-like default export to avoid breaks
const api = {
    interceptors: {
        request: { use: () => {} },
        response: { use: () => {} }
    },
    get: async () => ({ data: {} }),
    post: async () => ({ data: {} }),
    put: async () => ({ data: {} }),
    delete: async () => ({ data: {} })
};

export default api;